import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Swiper from "swiper";
import "swiper/swiper.min.css";
// 1. 引入你需要的组件
import "@/utils/vant.js";
// 2. 引入组件样式
import "vant/lib/index.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import ChartBlock from "@/components/echarts/ChartsBlock.vue"; //导入
import cookie from "js-cookie";
// import "@/utils/rem.js";
import "amfe-flexible";
//将cookie转换为 vue 原型
Vue.prototype.cookie = cookie;
//安装组件
Vue.use(ChartBlock);
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  Swiper,
  cookie,
  render: (h) => h(App),
}).$mount("#app");
